import { useDebounce } from '~/hooks'
import { useStEth2WstEthRate } from './useStEth2WstEthRate'

export const useWrapReceiveAmount = (amount: string | null) => {
  const fallbackAmount = amount || '0'
  const debouncedAmount = useDebounce(fallbackAmount, 500)
  const result = useStEth2WstEthRate(debouncedAmount)
  return result
}
